module.exports = __webpack_public_path__ + "static/media/spiderRune.2af1ad97.mp3";